import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { verifyECartOTP, encryptAES, decryptAES, cleanAuthContent } from '../../../Authentication/action';
import { closePopup, openPopup } from '../../../action';
import { sendOtpEcart, resendOtpEcart, savePreLoginDataEcart } from '../../action';
import './style.scss';
import { MODALS } from '../../../constants';
import ENV_CONFIG from '../../../../../../../config/environment';
import cookie from "react-cookies";
import moment from 'moment';
import UpdateFolio from '../UpdateFolio';
import { toast } from 'react-toastify';


const Folio = (props) => {
    const { verifyOtpData, closePopup, openPopup, verifyECartOTP, resendOtpEcart, sendOtpEcart, authValues, savePreLoginDataEcart, comingFromReplaceCart, cleanAuthContent } = props;
    const [folioList, setFolioList] = useState(null);
    const [activeFolio, setActiveFolio] = useState(null);
    const [cookiePreLogin, setCookiePreLogin] = useState(null);
    const [otpScreen, setOtpScreen] = useState(false);
    const [updateFolio, setUpdateFolio] = useState(false);
    let preLoginDataFromCookie = {};
    useEffect(() => {
        // console.log(cookie.load("CartDetails"));
        const isInvest = cookie.load("isInvest") == "true" || false;
        const arrayOfObj = isInvest ? Object.values(cookie.load("ProceedCartDetails")) : Object.values(cookie.load("CartDetails"));
        if (arrayOfObj) {
            let cartItems = [];
            let object = {};
            let totalAmount = 0;
            for (let i = 0; i < arrayOfObj.length; i++) {
                object = {
                    schemeName: arrayOfObj[i].scheme.name,
                    schemeCode: arrayOfObj[i].scheme.code,
                    amount: arrayOfObj[i]?.purchaseAmount == null ? 0:Number(arrayOfObj[i]?.purchaseAmount),
                    rupees: `Rs ${(arrayOfObj[i]?.purchaseAmount)?.toString()}`,
                    dividendOption: arrayOfObj[i].dividendOption,
                    liquid: arrayOfObj[i]?.liquid,
                    invType: activeFolio ? activeFolio.invType : null,
                    minorFlag: activeFolio ? activeFolio.minorFlag : null,
                    purchaseOpted: arrayOfObj[i].purchaseOpted,
                    sipOpted: arrayOfObj[i].sipOpted,
                    retirementApplicable: arrayOfObj[i].retirementApplicable,
                    cgfApplicable: arrayOfObj[i].cgfApplicable,
                    installmentAmount: Number(arrayOfObj[i]?.sipAmount),
                    errorExists: arrayOfObj[i].errorExists,
                    folioNumber: null,
                    frequency: 'OM'
                }
                if (arrayOfObj[i].sipOpted) {
                    object.sipDate = moment(arrayOfObj[i].sipDate).format("DD-MMM-YYYY")
                }
                if (arrayOfObj[i].sipOpted) {
                    object.toDate = moment(arrayOfObj[i].toDate).format("DD-MMM-YYYY")
                }
                cartItems.push(object);
            }
            for (let i = 0; i < cartItems.length; i++) {
                var tAmount = cartItems[i]?.amount == null ? '':cartItems[i]?.amount;
                var iAmount = cartItems[i]?.installmentAmount == null ? '':cartItems[i]?.installmentAmount;

                totalAmount +=  tAmount + iAmount;
            }
            preLoginDataFromCookie.totalAmount = Number(totalAmount);
            preLoginDataFromCookie.cartItems = cartItems;
            setCookiePreLogin(preLoginDataFromCookie);
            // console.log(preLoginDataFromCookie);
        }
    }, []);
    useEffect(() => {
        if (activeFolio) {
            let cartItems = cookiePreLogin.cartItems;
            let updatedcartItems = cartItems.map(item => ({
                ...item,
                invType: activeFolio.invType,
                minorFlag: activeFolio.minorFlag,
                folioNumber: activeFolio.folioNumber,
            }))
            setCookiePreLogin(currentValue => ({
                ...currentValue,
                cartItems: updatedcartItems,
            }));
        }
    }, [activeFolio]);
    useEffect(() => {
        let scrollToElement = require('scroll-to-element');
        scrollToElement(document.querySelector(".ecart-modal-folio"), {
            ease: 'linear',
            duration: 100,
        });
        if (verifyOtpData?.kycData?.apiLoaded && verifyOtpData?.kycData?.data?.folioList && Array.isArray(verifyOtpData?.kycData?.data?.folioList)) {
            const isInvest = cookie.load("isInvest") == "true" || false;
            let cartDetailCookie = isInvest ? cookie.load('ProceedCartDetails') || {} : cookie.load('CartDetails') || {};
            let isCGF = Object.values(cartDetailCookie)?.filter((ele) => {
                if (ele.cgfApplicable) return ele;
            })

            let isRetirement = Object.values(cartDetailCookie)?.filter((ele) => {
                if (ele.retirementApplicable) return ele;
            })

            if (isCGF.length > 0) {
                let result = verifyOtpData.kycData.data.folioList.filter((ele) => {
                    return ele.minorFlag;
                })

                setFolioList(result);
            }

            if (isRetirement.length > 0) {
                let result = verifyOtpData.kycData.data.folioList.filter((ele) => {
                    return !ele.minorFlag;
                })

                setFolioList(result);
            }

            if (isCGF.length === 0 && isRetirement.length === 0) setFolioList(verifyOtpData.kycData.data.folioList)
        }
        else if (verifyOtpData?.kycData?.apiLoaded && verifyOtpData?.kycData?.data?.kycVerifiedFlag && verifyOtpData?.kycData?.data?.message && verifyOtpData?.kycData?.data?.secretLink) {
            setOtpScreen(true);
            // redirectToOtp(verifyOtpData);
        }
    }, [verifyOtpData]);

    useEffect(() => {
        if (otpScreen && cookiePreLogin) {
            redirectToOtp(verifyOtpData)
        }
    }, [otpScreen, cookiePreLogin]);

    const onOtpSubmit = async (response, folio) => {
        let preLoginData = cookiePreLogin;
        const isInvest = cookie.load("isInvest") == "true" || false;
        const isJanNivesh = cookie.load("isJanNivesh") == "true" || false;
        preLoginData.folioNumber = folio ? folio : null;
        if(isInvest){
            preLoginData.linkId = response && response.data && response.data.linkID ? response.data.linkID : null;
            preLoginData.flowName = 'INVEST_NOW_WEBSITE';
        }
        if(isJanNivesh){
            preLoginData.janNiveshOpted = true;
        }
        // console.log(preLoginData);
        if (response && response.data && response.data.uuid) {
            let res = await savePreLoginDataEcart((JSON.stringify(preLoginData)), response.data.uuid);
            if (res && !res.status) {
                const notify = () => toast.error(res.message);
                notify();
            }
            else if (res && res.status && res.data && !res.data.cartExists) {
                const url = `${ENV_CONFIG.INVESTOR_BASE_URL}/ecart/${response.data.uuid}`;
                window.open(url, '_self');
            }
            else if (res && res.status && res.data && res.data.cartExists) {
                let modalData = {
                    journeyPage: 7,
                    modalClass: 'ecart-modal-replace-items',
                    uuid: response.data.uuid,
                    folio: folio ? folio : null,
                    url: `${ENV_CONFIG.INVESTOR_BASE_URL}/ecart/${response.data.uuid}`,
                    preLoginData: preLoginData,
                };
                openPopup(MODALS.REPLACE_ITEMS_ECART, modalData);
            }
        }
    }

    const onOtpSend = async () => {
        let data = {
            folioNo: activeFolio?.folioNumber,
        }
        let res = await sendOtpEcart(data);
        let modalData = {
            modalClass: 'verify-otp-modal',
            verifyECartOTP,
            resendOtp: resendOtpEcart,
            closeAction: closePopup,
            dob: verifyOtpData && verifyOtpData.objectt && verifyOtpData.objectt.dob ? moment(verifyOtpData.objectt.dob).format("DD-MMM-YYYY") : '',
            pan: verifyOtpData && verifyOtpData.objectt && verifyOtpData.objectt.pan ? verifyOtpData.objectt.pan : '',
            message: res?.data?.message,
            secretLink: res?.data?.secretLink,
            registrationType: 'EXISTING',
            journey: 'E_CART',
            encrypt: encryptAES,
            decrypt: decryptAES,
            folioNo: activeFolio.folioNumber,
            onOtpSubmit,
            cookiePreLogin,
        }
        if (!res.data || !res?.data?.secretLink) {
            setUpdateFolio(true);
            openToast();
        }
        if (res?.data && res?.data?.secretLink) openPopup(MODALS.VERIFY_OTP_ECART, modalData);
    }

    const redirectToOtp = async (verifyOtpData) => {
        let modalData = {
            modalClass: 'verify-otp-modal',
            verifyECartOTP,
            resendOtp: resendOtpEcart,
            closeAction: closePopup,
            dob: verifyOtpData.objectt.dob,
            pan: verifyOtpData.objectt.pan,
            message: verifyOtpData.kycData.data.message,
            secretLink: verifyOtpData.kycData.data.secretLink,
            registrationType: 'NEW',
            journey: 'E_CART',
            encrypt: encryptAES,
            decrypt: decryptAES,
            onOtpSubmit,
            cookiePreLogin,
        }
        if (cookiePreLogin) {
            openPopup(MODALS.VERIFY_OTP_ECART, modalData);
        }
    }

    useEffect(() => {
        if (folioList && folioList.length > 0) {
            setActiveFolio(folioList[0]);
        }
    }, [folioList]);

    const onFolioClick = (folio) => {
        setUpdateFolio(false);
        setActiveFolio(folio);
    }

    const closeAction = () => {
        cleanAuthContent();
        closePopup();
    }

    const openToast = () => {
        toast.error(`You cannot proceed with folio number ${activeFolio.maskedFolioNumber}. To proceed, first update the contact details in that folio.`, {
            position: toast.POSITION.TOP_RIGHT
        });
    }

    if (otpScreen === false)
        return (
            <div className="folio-list-modal">
                <div className='foliohead'>
                    <h3>Select a Folio to proceed</h3>
                    <div className='close-icon' onClick={closeAction} ></div>
                </div>
                <div className='roww header'>
                    <div className="columnn">Folio Number</div>
                    <div className="columnn">Mobile Number</div>
                    <div className="columnn">Email ID</div>
                </div>
                <div className={updateFolio ? 'all-folios-list' : 'all-folio-list'}>
                    {folioList && folioList.map((folio, index) => {
                        if (folio.activeFlag)
                            return (
                                <div className='folio-list'>
                                    <label className='roww' name='folio-select'>
                                        <div className='folioinputdiv'>
                                            <input key={folio.folioNumber} className="folioinput" type="radio" name='folio-select' value={folio.folioNumber} checked={activeFolio && activeFolio.folioNumber == folio.folioNumber} onChange={() => onFolioClick(folio)} />
                                            <div className="columnn columntext">{folio.maskedFolioNumber}</div>
                                        </div>
                                        <div className="columnn">{folio.mobileNumber}</div>
                                        <div className="columnn">{folio.email}</div>
                                    </label>
                                </div>
                            )
                    })}
                </div>
                {/* {updateFolio && <UpdateFolio folioNumber={activeFolio?.maskedFolioNumber}></UpdateFolio>} */}
                <div className='otpdiv'>
                    <button className='send-otp' disabled={activeFolio === null || updateFolio} onClick={() => onOtpSend()}>
                        Send OTP
                    </button>
                </div>
            </div>
        );
    else return 'New investor';
}

const mapStateToProps = (state) => ({
    commonContent: state.commonContent,
    eCart: state.eCart,
});

const mapDispatchToProps = (dispatch) => ({
    verifyECartOTP: bindActionCreators(verifyECartOTP, dispatch),
    resendOtpEcart: bindActionCreators(resendOtpEcart, dispatch),
    sendOtpEcart: bindActionCreators(sendOtpEcart, dispatch),
    savePreLoginDataEcart: bindActionCreators(savePreLoginDataEcart, dispatch),
    closePopup: bindActionCreators(closePopup, dispatch),
    openPopup: bindActionCreators(openPopup, dispatch),
    cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch)
});

const FolioContainer = connect(mapStateToProps, mapDispatchToProps)(Folio);

export default FolioContainer;